import type { BriefSummary } from "@/lib/brief";

type Color = BriefSummary["brandColors"][number];

export function ColorSwatchGrid({ colors }: { colors: Color[] }) {
  if (!colors || colors.length === 0) {
    return <span className="text-muted-foreground">—</span>;
  }
  return (
    <div className="flex flex-wrap gap-3">
      {colors.map((c, i) => (
        <div key={`${c.hex}-${c.label}-${i}`} className="space-y-1 text-xs">
          <div
            className="size-12 rounded border"
            style={{ background: c.hex }}
            aria-label={c.label || c.hex}
          />
          <div className="font-mono uppercase text-[11px]">{c.hex}</div>
          {c.label ? (
            <div className="text-muted-foreground text-[11px]">{c.label}</div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
